var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wwd-banner flex column justify-center align-start",style:(_vm.bgStyle)},[_c('div',{staticClass:"title",attrs:{"data-aos":"fade-up"}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"seperator"}),_c('div',{staticClass:"desc",attrs:{"data-aos":"fade-up"}},[_vm._v(_vm._s(_vm.desc))])])
}
var staticRenderFns = []

export { render, staticRenderFns }